// extracted by mini-css-extract-plugin
module.exports = {"resultType":"ResultType_resultType__38sYE"};